import React, { FC, memo, useEffect } from "react";
import OnboardingSteps from "../../components/OnboardingSteps";

/**
 * Onboarding Page Props Interface
 * @interface OnboardingPageProps
 */
interface OnboardingPageProps {
  /** pass the children pages in the layout */
  children: React.ReactNode;
  setLayoutReady: (ready: boolean) => void
}

const Onboarding: FC<OnboardingPageProps> = ({ children, setLayoutReady }) => {
  useEffect(() => {
    setLayoutReady(true);
  }, [])
  
  return (
    <div className="d-flex flex-column flex-lg-row">
      <OnboardingSteps />
      <div className="steps-content w-100 py-40px">{children}</div>
    </div>
  );
};

export default memo(Onboarding);
